import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

// 防抖控制器配置
const DEBOUNCE_THRESHOLD = 500 // 防抖时间窗口
const CLEANUP_DELAY = 500    // 记录清理延迟
// 请求记录存储（使用Map提升性能）
const pendingRequests = new Map()
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: Number(process.env.VUE_APP_TIMEOUT) || 15000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截器
service.interceptors.request.use(config => {
  // 注入Token
  if (store.getters.token) {
    config.headers['Authorization'] ="Bear "+getToken()
    // config.headers['sifei-zhizao-token'] = getToken()
  }
  // 防抖处理核心逻辑
  const requestKey = generateRequestKey(config)
  const lastRequestTime = pendingRequests.get(requestKey)
  if (lastRequestTime) {
    const timeDiff = Date.now() - lastRequestTime
    if (timeDiff < DEBOUNCE_THRESHOLD && config.debounce) {
      Message.warning({ message: '操作过于频繁，请稍后再试', duration: 2000 })
      return Promise.reject(new Error('request_debounced'))
    }
  }

  // 更新请求记录
  pendingRequests.set(requestKey, Date.now())
  setTimeout(() => pendingRequests.delete(requestKey), CLEANUP_DELAY)
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(
  response => handleResponse(response),
  error => handleError(error)
)
/* 核心工具函数 */

// 生成唯一请求标识
function generateRequestKey(config) {
  return `${config.method}:${config.url}:${JSON.stringify(config.params)}:${JSON.stringify(config.data)}`
}
// 判断是否是 BigDecimal 字符串（可自定义规则）
function isBigDecimalString(str) {
  return /^-?\d+(\.\d+)?$/.test(str); // 简单正则匹配数字字符串
}
// 递归转换对象中的数字字符串
function convertStringToNumber(obj) {
  if (Array.isArray(obj)) {
    return obj.map(convertStringToNumber);
  } else if (obj && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const value = obj[key];
      if (typeof value === 'string' && isBigDecimalString(value)) {
        acc[key] = parseFloat(value);
      } else {
        acc[key] = convertStringToNumber(value);
      }
      return acc;
    }, {});
  } else {
    return obj;
  }
}
// 处理成功响应
function handleResponse(response) {
// 文件流处理
  if (response.config.responseType === 'blob') {
    handleFileDownload(response)
    return Promise.resolve()
  }
  // 处理业务响应
  const res = response.data
  switch (res.statusCode) {
    case 200:
      return res
    case 401:
      location.reload();
      console.log('未授权!!!!!!!!!!!!!!!!!!!!!!!!!')
      // handleUnauthorized() // 未授权处理
      // return Promise.reject(res)
      return response
    case 302:
      return response
    default:
      Message.error(res.message || '业务请求异常')
      return Promise.reject(res)
  }
}

// 处理文件下载
function handleFileDownload(response) {
  try {
    const res = response.data
    if (response.config.responseType == 'blob') {//文件流
        const temp = response.headers["content-disposition"].split(";")[1].split("filename=")[1];
        const fileName = decodeURIComponent(temp)
        var elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        var blob = new Blob([response.data], { type: 'application/x-msdownload' });
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
    }
  } catch (error) {
    Message.error('文件下载失败: ' + error.message)
    throw error
  }
}

// 处理未授权
function handleUnauthorized() {
  if (!store.getters.token) return
  MessageBox.confirm('登录状态已过期，请重新登录1', '提示', {
    confirmButtonText: '重新登录',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    
  }).catch(() => {// 取消操作不处理
    
  })
}
function handleError(error) {// 统一错误处理
  if (error.message === 'request_debounced') {// 防抖错误不处理
    return Promise.reject(error)
  }
  if (!window.navigator.onLine) {// 网络错误处理
    Message.error('网络连接不可用，请检查网络设置')
    return Promise.reject(error)
  }
  if (error.response) {// HTTP状态码处理
    const status = error.response.status
    if(error.response.data.statusCode==401 || error.response.data.statusCode==22401){
      location.reload();
    }
    const errorMessage = error.response.data.data || `请求失败（${status}）`
    Message.error(errorMessage)
  } else {
    Message.error('请求超时或服务器异常')
  }
  return Promise.reject(error)
}

export default service
